<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div :class="bodyClassName + ' tabulator-parent'">
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-house-signal"></i> {{ _('Smart Devices') }}</h3>
        </div>
      </div>
      <editor-tabs id="tabNavi" :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <transition-group name="fade">
          <div v-bind="tabPanel('devices')" class="tab-pane active" id="devices" v-if="isTabActive('devices')" key="devices">
            <div class="row">
              <div class="col-sm-6">
                <h3>{{ _('Devices') }}</h3>
              </div>
            </div>
            <div class="flex-row space-between">
              <div class="flex-row">
                <div class="list-filter-col">
                  <div class="input-group">
                    <input class="form-control" id="deviceSearchField" type="text" v-model="deviceSearch" :placeholder="_('Keyword search')" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-success"><i class="fa fa-fw fa-search"></i></button>
                    </span>
                  </div>
                </div>
                <div class="list-filter-col">
                  <div class="input-group">
                    <div class="input-group-addon">{{ _('Display') }}</div>
                    <select class="form-control" id="deviceTypeFilter" v-model="deviceType">
                      <option value="all">{{ _('All') }}</option>
                      <optgroup :label="_('Temperature')">
                        <option value="temperature">{{ _('All') }}</option>
                        <option value="adax">{{ _('Adax heater') }}</option>
                      </optgroup>
                      <optgroup :label="_('Locking')">
                        <option value="lock">{{ _('All') }}</option>
                        <option value="seam" v-if="isFeatureEnabled('seam')">{{ _('Seam') }}</option>
                        <option value="igloo" v-if="!isFeatureEnabled('seam') || settings.igloohome_apikey">{{ _('Igloohome') }}</option>
                        <option value="ratna">{{ _('Ratna') }}</option>
                        <option value="yale" v-if="!isFeatureEnabled('seam') || settings.igloohome_apikey">{{ _('Yale') }}</option>
                        <option value="seam-unmanaged" v-if="isFeatureEnabled('seam')">{{ _('Seam (unmanaged)') }}</option>
                      </optgroup>
                      <optgroup :label="_('Access Control Systems')" v-if="isFeatureEnabled('seam')">
                        <option value="acs">{{ _('All') }}</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
              </div>
              <div class="flex-row">
                <button type="button" class="btn btn-success btn-new link-device" v-on:click="linkDeviceDialog"><i class="fa fa-fw fa-link"></i> {{ _('Link') }}</button>
                <button type="button" class="btn btn-success btn-new refresh-devices" v-on:click="refreshDevices"><i class="fa fa-fw fa-refresh"></i> {{ _('Refresh') }}</button>
              </div>
            </div>
            <Datatable :url="devicesUrl" :search="deviceSearch" :type-filter="deviceType" :options="devicesTableOptions" ref="datatableDevices" v-on:data="devicesTableEvent" />
          </div>
          <div v-bind="tabPanel('services')" class="tab-pane active" id="services" v-if="isTabActive('services')" key="services">
            <div class="row">
              <div class="col-sm-6 leftcol">
                <h3>{{ _('Linked Services') }}</h3>
                <h4 style="margin-top: 20px"><i class="fa fa-fw fa-lock"></i> {{ _('Locking') }}</h4>
                <div class="panel-group flex-panel" id="channelaccordion" role="tablist" aria-multiselectable="true">
                  <div :class="servicePanelClass('seam')" v-if="isFeatureEnabled('seam')">
                    <div class="panel-heading" role="tab" id="channelHeadingZero">
                      <h4 class="panel-title">
                      <a class="collapsed" data-toggle="collapse" data-parent="#channelaccordion" href="javascript:;" :aria-expanded="isPanelOpen('channelCollapseZero')" :aria-controls="'channelCollapseZero'" v-on:click="togglePanel('channelCollapseZero')">
                        <span class="title-text">{{ _('Smart Locks (Seam)') }}</span>
                        <span class="indicator"></span>
                      </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="channelCollapseZero" class="panel-collapse" role="tabpanel" aria-labelledby="channelHeadingZero" v-if="isPanelOpen('channelCollapseZero')">
                        <div class="panel-body">
                          <p>{{ _('Connect to many smart lock manufacturers, including Yale, Igloohome, August, Nuki, Schlage, Kwikset, Smartthings.') }}</p>
                          <table v-if="seamConnectedAccounts.length" class="table">
                            <tbody>
                              <template v-for="account in seamConnectedAccounts" :key="account.id">
                                <tr>
                                  <td><i class="fa fa-fw fa-check"></i> <strong>{{ account.title }}</strong><br />
                                    {{ account.email }}
                                  </td>
                                  <td align="right">
                                    <button class="btn btn-danger" v-on:click="deleteSeamConnectedAccountDialog(account.id)"><i class="fa fa-fw fa-trash"></i></button>
                                  </td>
                                </tr>
                                <tr v-if="seamConnectedAccountWarnings[account.id]" :key="`warning-${account.id}`">
                                  <td>
                                    <div v-for="warning in seamConnectedAccountWarnings[account.id]" class="alert alert-warning" style="margin-bottom: 5px">{{ warning.message }}</div>
                                  </td>
                                  <td align="right">
                                    <button class="btn btn-success" v-on:click="seamWebviewDialog"><i class="fa fa-fw fa-link"></i> {{ _('Reauthorize') }}</button>
                                  </td>
                                </tr>
                                <tr v-if="seamConnectedAccountErrors[account.id]" :key="`error-${account.id}`">
                                  <td>
                                    <div v-for="error in seamConnectedAccountErrors[account.id]" class="alert alert-warning" style="margin-bottom: 5px">{{ error.message }}</div>
                                  </td>
                                  <td align="right">
                                    <button class="btn btn-success" v-on:click="seamWebviewDialog"><i class="fa fa-fw fa-link"></i> {{ _('Reauthorize') }}</button>
                                  </td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                          <div class="form-group">
                            <button class="btn btn-success" v-on:click="seamWebviewDialog"><i class="fa fa-fw fa-link"></i> {{ _('Add') }}</button>
                          </div>
                          <p>{{ _('Connecting smart locks is a paid service. Detailed pricing can be found at:') }} <a href="https://johku.fi/fi/hinnatjapalvelut/alylukitus" target="_blank">https://johku.fi/fi/hinnatjapalvelut/alylukitus</a></p>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <div :class="servicePanelClass('igloohome')" v-if="!isFeatureEnabled('seam') || settings.igloohome_apikey">
                    <div class="panel-heading" role="tab" id="channelHeadingOne">
                      <h4 class="panel-title">
                      <a class="collapsed" data-toggle="collapse" data-parent="#channelaccordion" href="javascript:;" :aria-expanded="isPanelOpen('channelCollapseOne')" :aria-controls="'channelCollapseOne'" v-on:click="togglePanel('channelCollapseOne')">
                        <span class="title-text">{{ _('Igloohome') }}</span>
                        <span class="indicator"></span>
                      </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="channelCollapseOne" class="panel-collapse" role="tabpanel" aria-labelledby="channelHeadingOne" v-if="isPanelOpen('channelCollapseOne')">
                        <div class="panel-body">
                          <div class="form-group">
                            <label for="igloohome_apikey">{{ _('Igloohome API key') }}</label>
                            <input class="form-control" v-model="settings.igloohome_apikey" type="text" />
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <div :class="servicePanelClass('ratna')">
                    <div class="panel-heading" role="tab" id="channelHeadingTwo">
                      <h4 class="panel-title">
                        <a class="collapsed" data-toggle="collapse" data-parent="#channelaccordion" href="javascript:;" :aria-expanded="isPanelOpen('channelCollapseTwo')" :aria-controls="'channelCollapseTwo'" v-on:click="togglePanel('channelCollapseTwo')">
                        <span class="title-text">{{ _('Ratna') }}</span>
                        <span class="indicator"></span>
                      </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="channelCollapseTwo" class="panel-collapse" role="tabpanel" aria-labelledby="channelHeadingTwo" v-if="isPanelOpen('channelCollapseTwo')">
                        <div class="panel-body">
                          <div class="form-group">
                            <label for="ratna_url">{{ _('Ratna API URL') }}</label>
                            <input class="form-control" v-model="settings.ratna_url" type="text" />
                          </div>
                          <div class="form-group">
                            <label for="ratna_username">{{ _('Ratna user name') }}</label>
                            <input class="form-control" v-model="settings.ratna_username" type="text" />
                          </div>
                          <div class="form-group">
                            <label for="ratna_password">{{ _('Ratna password') }}</label>
                            <input class="form-control" v-model="settings.ratna_password" type="text" />
                          </div>
                          <div class="form-group">
                            <label for="ratna_password">{{ _('Ratna apartments') }}</label>
                            <draggable-multi-selector v-model="ratnaApartments" :items="ratnaApartments" itemProperty="name" :selectorTitle="_('Link a Loyalty card')" />
                            <button class="btn btn-success" type="button" v-on:click="addRatnaApartmentDialog">{{ _('Add apartment') }}</button>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <div :class="servicePanelClass('yale')" v-if="!isFeatureEnabled('seam') || settings.yale_apitoken">
                    <div class="panel-heading" role="tab" isServiceEnabled="channelHeadingThree">
                      <h4 class="panel-title">
                        <a class="collapsed" data-toggle="collapse" data-parent="#channelaccordion" href="javascript:;" :aria-expanded="isPanelOpen('channelCollapseThree')" :aria-controls="'channelCollapseThree'" v-on:click="togglePanel('channelCollapseThree')">
                          <span class="title-text">{{ _('Yale') }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="channelCollapseThree" class="panel-collapse" role="tabpanel" aria-labelledby="channelHeadingThree" v-if="isPanelOpen('channelCollapseThree')">
                        <div class="panel-body">
                          <div class="form-group" v-if="settings.yale_apitoken">
                            <label for="yale_apitoken">{{ _('Yale API token') }}</label>
                            <input class="form-control" v-model="settings.yale_apitoken" type="text" disabled="disabled" />
                          </div>
                          <div class="form-group">
                            <button class="btn btn-info" v-on:click="authenticateDialog">{{ _('Authenticate') }}</button>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
                <h4 style="margin-top: 20px"><i class="fa fa-fw fa-thermometer"></i> {{ _('Temperature') }}</h4>
                <div class="panel-group flex-panel" id="channelaccordion" role="tablist" aria-multiselectable="true">
                  <div :class="servicePanelClass('adax')">
                    <div class="panel-heading" role="tab" isServiceEnabled="channelHeadingFour">
                      <h4 class="panel-title">
                        <a class="collapsed" data-toggle="collapse" data-parent="#channelaccordion" href="javascript:;" :aria-expanded="isPanelOpen('channelCollapseFour')" :aria-controls="'channelCollapseFour'" v-on:click="togglePanel('channelCollapseFour')">
                          <span class="title-text">{{ _('Adax') }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="channelCollapseFour" class="panel-collapse" role="tabpanel" aria-labelledby="channelHeadingFour" v-if="isPanelOpen('channelCollapseFour')">
                        <div class="panel-body">
                          <div class="form-group">
                            <label for="adax_clientid">{{ _('Adax Client ID') }}</label>
                            <input class="form-control" v-model="settings.adax_clientid" type="text" />
                          </div>
                          <div class="form-group">
                            <label for="adax_clientsecret">{{ _('Adax Client Secret') }}</label>
                            <input class="form-control" v-model="settings.adax_clientsecret" type="text" />
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('actions')" class="tab-pane active" id="actions" v-if="isTabActive('actions')" key="actions">
            <div class="row">
              <div class="col-sm-6">
                <h3>{{ _('Actions') }}</h3>
              </div>
            </div>
            <div class="list-filter-row">
              <div class="list-filter-col">
                <div class="form-group">
                  <div class="input-group">
                    <input class="form-control" id="searchField" type="text" v-model="search" :placeholder="_('Keyword search')" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-success"><i class="fa fa-fw fa-search"></i></button>
                    </span>
                  </div>
                </div>
              </div>
              <div class="list-filter-col" v-if="!showExactRange">
                <div class="form-group">
                  <div class="input-group">
                    <div class="input-group-addon">{{ _('Date range') }}</div>
                    <select class="form-control" v-model="range">
                      <option value="upcoming" selected>{{ _('Upcoming') }}</option>
                      <option value="all">{{ _('All') }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="list-filter-col" v-if="showExactRange">
                <div class="rangeFields pull-right">
                  <div class="form-inline">
                    <div class="form-group">
                      <DatePicker v-model="dateStart" :max-date="dateEnd" :shortLocale="shortLocale" :staticInput="true"></DatePicker>
                    </div>
                    <label for="endDate"> - </label>
                    <div class="form-group">
                      <DatePicker v-model="dateEnd" :min-date="dateStart" :shortLocale="shortLocale" :staticInput="true"></DatePicker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="list-filter-col">
                <button id="selectRange" type="button" class="btn btn-default" v-on:click="selectRange" v-if="!showExactRange"><div class=""></div>{{ _('Select exact date range') }}</button>
                <button id="unselectRange" type="button" class="btn btn-default" v-on:click="unselectRange" v-else><div class=""></div>{{ _('Cancel') }}</button>
              </div>
            </div>
            <Datatable :url="smartdeviceactionsUrl" :search="search" :start-date-filter="startDateFilter" :end-date-filter="endDateFilter" :options="smartdeviceactionsTableOptions" ref="datatableSmartdeviceActions" />
          </div>
        </transition-group>
      </div>
    </div>
    <nav class="save-bar" v-if="isSaveBarVisible">
      <div class="row">
        <div class="col-md-12">
          <div class="pull-right">
            <button class="btn btn-default" v-on:click="close" v-if="showCloseButton"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
            <button class="btn btn-success" v-on:click="save" :disabled="!isSaveButtonEnabled"><i :class="'fa fa-fw fa-' + saveButtonIcon"></i> {{ saveButtonText }}</button>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import axios from 'axios'
import components from '~/lib/components'
import formatters from '~/lib/formatters'
import modals from '~/lib/modals'
import settingseditors from '~/lib/settingseditors'
import settingshelpers from '~/lib/settingshelpers'
import slidetransition from '~/lib/slidetransition'
import { Datatable, DraggableMultiSelector, SeamConnectWebview } from '#components'
import { DateTime } from 'luxon'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      showExactRange: false,
      dateStart: false,
      dateEnd: false,
      deviceSearch: '',
      deviceType: 'all',
      search: '',
      range: 'upcoming',
      activeTab: 'devices',
      devices: [],
      seamConnectedAccountWarnings: {},
      seamConnectedAccountErrors: {},
      devicesTableOptions: {
        fixWidths: true,
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 70,
          responsive: 0
        },
        {
          title: _('Name'),
          field: 'name',
          formatter: this.smartDeviceNameFormatter(),
          widthGrow: 4,
          responsive: 0
        },
        {
          title: _('Type'),
          field: 'subtype',
          formatter: this.smartDeviceSubtypeFormatter(),
          widthGrow: 3,
          responsive: 0
        },
        ],
        initialSort: [{
          column: 'name',
          dir: 'asc'
        }],
        rowClick (e, row) {
          const id = row.getCell('id').getValue()
          const name = row.getCell('name').getValue()
          $this.editDevice(id, name)
        }
      },
      smartdeviceactionsTableOptions: {
        rowFormatter: this.smartdeviceactionRowFormatter(),
        fixWidths: true,
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 100,
          responsive: 0
        },
        {
          title: _('Time'),
          field: 'start_ts',
          formatter: this.dateAndTimeFormatter(),
          widthGrow: 4,
          responsive: 0
        },
        {
          title: _('End time'),
          field: 'end_ts',
          formatter: this.dateAndTimeFormatter(),
          widthGrow: 4,
          responsive: 0
        },
        {
          title: _('Smart Device'),
          field: 'smartdevice_name',
          widthGrow: 1,
          responsive: 1
        },
        {
          title: _('Type'),
          field: 'subtype',
          formatter: this.smartDeviceSubtypeFormatter(),
          widthGrow: 3,
          responsive: 0
        },
        {
          title: _('Reservation'),
          field: 'reservation_name',
          widthGrow: 1,
          responsive: 1
        },
        {
          title: _('Resource'),
          field: 'resource_name',
          widthGrow: 1,
          responsive: 1
        },
        ],
        initialSort: [{
          column: 'start_ts',
          dir: 'asc'
        }],
        rowClick (e, row) {
          const id = row.getCell('id').getValue()
          const full = row.getData()
          const kind = full.kind
          const name = row.getCell('smartdevice_name').getValue()
          $this.displaySmartDeviceAction(id, kind, name)
        }
      }
    }
  },
  mixins: [components, formatters, modals, settingseditors, settingshelpers, slidetransition],
  computed: {
    tabList () {
      return this.editorTabs([
        { id: 'devices', label: this._('Devices') },
        { id: 'services', label: this._('Linked Services') },
        { id: 'actions', label: this._('Actions') }
      ])
    },
    devicesUrl () {
      return this.baseDomain + this.shopId + '/smartdevices.json?apikey=' + this.apiKey + '&rawformat=true'
    },
    smartdeviceactionsUrl () {
      return this.baseDomain + this.shopId + '/smartdeviceactions.json?apikey=' + this.apiKey + '&rawformat=true'
    },
    startDateFilter: {
      get () {
        if (this.dateStart && this.dateEnd) {
          return DateTime.fromJSDate(this.dateStart, { zone: this.timezone }).toFormat('d.M.yyyy') + '-' + DateTime.fromJSDate(this.dateEnd, { zone: this.timezone }).toFormat('d.M.yyyy')
        }
        switch (this.range) {
          case 'upcoming':
          case 'all':
            return this.range
        }
        return ''
      },
      set (newValue) {
        if (!newValue || !newValue.match || !newValue.match('-')) {
          switch (newValue) {
            case 'upcoming':
            case 'all':
              this.range = newValue
              break
          }
          this.dateStart = false
          this.dateEnd = false
          this.showExactRange = false
          return
        }
        this.setExactRangeFromFilter(newValue)
      }
    },
    endDateFilter: {
      get () {
        switch (this.range) {
          case 'upcoming':
          case 'all':
            return this.range
        }
        return ''
      },
      set (newValue) {
        switch (newValue) {
          case 'upcoming':
          case 'all':
            this.range = newValue
            break
        }
      }
    },
    showCloseButton () {
      if (this.isModal || (this.componentTrail && this.componentTrail.length > 1)) {
        return true
      }
      return false
    },
    ratnaApartments: {
      get () {
        return this.settings.ratna_apartments ? JSON.parse(this.settings.ratna_apartments) : []
      },
      set (newValue) {
        this.settings.ratna_apartments = JSON.stringify(newValue)
      }
    },
    isSaveBarVisible () {
      return this.activeTab !== 'devices' && this.activeTab !== 'actions'
    },
    seamConnectedAccounts () {
      return this.settings.seam_connected_accounts ? JSON.parse(this.settings.seam_connected_accounts) : []
    }
  },
  methods: {
    devicesTableEvent (data) { // This overrides the default event handler because the templates table has non-standard variables for search
      if (data) {
        if (data.filters) {
          for (let i = 0; i < data.filters.length; i++) {
            let f = data.filters[i]
            switch (f.field) {
              case 'search':
                if (!this.deviceSearch) { // We need to check this, otherwise the search field will start "eating" characters
                  this.deviceSearch = f.value
                }
                break
              case 'type':
                this.deviceType = f.value
                break
            }
          }
        }
      }
    },
    selectRange () {
      this.showExactRange = true
    },
    unselectRange () {
      this.showExactRange = this.dateStart = this.dateEnd = false
    },
    inputDateStart (newValue) {
      this.dateStart = newValue
    },
    inputDateEnd (newValue) {
      this.dateEnd = newValue
    },
    async refreshDevices() {
      await axios.get(this.baseDomain + this.shopId + '/smartdevices.json?refresh=all&apikey=' + this.apiKey)
      if (this.$refs.datatableDevices && this.$refs.datatableDevices.reload) {
        this.$refs.datatableDevices.reload()
      }
    },
    linkDeviceDialog () {
      this.showDialog({
        title: this._('Connect to shared devices from another shop'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Link'),
            class: 'success',
            icon: 'check',
            requiredFields: ['shopId'],
            handler: (data) => {
              this.linkDevices(data.shopId)
            }
          }
        ],
        fields: [
          {
            title: this._('Shop ID'),
            type: 'text',
            name: 'shopId',
          }
        ]
      })
    },
    async linkDevices (shopId) {
      try {
        await axios.post(this.baseDomain + this.shopId + '/smartdevices.json?apikey=' + this.apiKey, { shopid: shopId })
      } catch (e) {
        this.showError(e)
        return
      }
      // await this.refreshDevices()
      window.location.reload()
    },
    authenticateDialog () {
      this.showDialog({
        title: this._('Authenticate'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Send'),
            class: 'success',
            icon: 'check',
            handler: this.sendAuthenticationRequest,
            requiredFields: ['email', 'password']
          }
        ],
        fields: [
          {
            title: this._('Email'),
            type: 'email',
            name: 'email',
            placeholder: this._('Enter your Yale account email address'),
          },
          {
            title: this._('Password'),
            type: 'password',
            name: 'password',
            placeholder: this._('Enter your Yale account password'),
          }
        ]
      })
    },
    async sendAuthenticationRequest (data) {
      const postData = {
        email: data.email,
        password: data.password
      }
      try {
        await axios.patch(this.baseDomain + this.shopId + '/yaleusers.json?apikey=' + this.apiKey, postData)
      } catch(e) {
        this.showError(this._('Authentication request unsuccessful, please try again later.'))
        return
      }
      try {
        await axios.get(this.baseDomain + this.shopId + '/yaleusers.json?apikey=' + this.apiKey)
      } catch(e) {
        this.sendVerificationCodeRequest({ email: data.email })
        return
      }
      this.loadSmartDeviceSettings()
    },
    /*
    verificationDialog () {
      this.showDialog({
        title: this._('Authenticate'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Send'),
            class: 'success',
            icon: 'check',
            handler: this.sendVerificationCodeRequest,
            requiredFields: ['email']
          }
        ],
        fields: [
          {
            title: this._('Email'),
            type: 'email',
            name: 'email',
            placeholder: this._('Enter your Yale account email address'),
          }
        ]
      })
    },
    */
    async sendVerificationCodeRequest (data) {
      const postData = {
        email: data.email
      }
      try {
        await axios.patch(this.baseDomain + this.shopId + '/yaleusers.json?apikey=' + this.apiKey, postData)
      } catch(e) {
        this.showError(this._('Authentication request unsuccessful, please try again later.'))
        return
      }
      this.confirmVerificationCodeDialog(data.email)
    },
    confirmVerificationCodeDialog (email) {
      this.showDialog({
        title: this._('Confirm verification code'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Send'),
            class: 'success',
            icon: 'check',
            handler: this.confirmVerificationCode(email),
            requiredFields: ['code']
          }
        ],
        fields: [
          {
            title: this._('Code'),
            type: 'text',
            name: 'code',
            placeholder: this._('Enter the Yale verification code from your email'),
          }
        ]
      })
    },
    confirmVerificationCode (email) {
      return async (data) => {
        let response
        const postData = {
          code: data.code,
          email: email
        }
        try {
          response = await axios.patch(this.baseDomain + this.shopId + '/yaleusers.json?apikey=' + this.apiKey, postData)
        } catch(e) {
          this.showError(this._('Verification failed.'))
          return
        }
        this.loadSmartDeviceSettings()
      }
    },
    addRatnaApartmentDialog () {
      this.showDialog({
        title: this._('Add apartment'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Add'),
            class: 'success',
            icon: 'check',
            handler: this.addRatnaApartment,
            requiredFields: ['id', 'name'],
          }
        ],
        fields: [
          {
            title: this._('ID'),
            type: 'text',
            name: 'id',
            placeholder: this._('Enter the apartment id'),
          },
          {
            title: this._('Name'),
            type: 'text',
            name: 'name',
            placeholder: this._('Enter a descriptive name for the apartment'),
          }
        ]
      })
    },
    addRatnaApartment (data) {
      this.ratnaApartments.push(data)
      this.ratnaApartments = this.ratnaApartments.filter(a => a !== null)
    },
    editDevice (id, name, activeTab, skipState) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'SmartDeviceDetails',
        title: this._('Smart Device') + ' ' + id + (name ? ': ' + name : ''),
        width: 6,
        data: {
          deviceId: id,
          activeTab
        },
        skipState
      })
    },
    displaySmartDeviceAction (id, kind, name, activeTab, skipState) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'SmartDeviceActionDetails',
        title: this._('Smart Device Action') + ' ' + id + (name ? ': ' + name : ''),
        width: 6,
        data: {
          actionId: id,
          actionKind: kind,
          activeTab
        },
        skipState
      })
    },
    async seamWebviewDialog () {
      try {
        let done = false
        const response = await axios.post(this.baseDomain + this.shopId + '/seamlocks.json?apikey=' + this.apiKey, { connect: true })
        const popup = window.open(response.data, '_blank')
        const handleFocus = async () => {
          // For some reason the popup.closed is false unless we wait a bit
          await new Promise(resolve => setTimeout(resolve, 1000))
          if (popup.closed && !done) {
            done = true
            window.removeEventListener('focus', handleFocus)
            await this.refreshDevices()
            window.location.reload()
          }
        }
        window.addEventListener('focus', handleFocus)
        // This was the old, less hacky way, but can't be used because Salto KS doesn't support iframes
        /*
        this.showModal('seamwebview', SeamConnectWebview, {
          props: {
            url: response.data
          },
          backgroundEvents: {
            loginSuccessful: async () => {
              if (!done) {
                done = true
                await this.refreshDevices()
                window.location.reload()
              }
            }
          }
        })
        */
      } catch (e) {
        this.showError(e)
      }
    },
    deleteSeamConnectedAccountDialog (accountId) {
      this.showDialog({
        title: this._('Delete Seam account?'),
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Delete'),
            class: 'danger',
            icon: 'trash',
            handler: () => {
              this.deleteSeamConnectedAccount(accountId)
            }
          }
        ]
      })
    },
    async deleteSeamConnectedAccount (accountId) {
      try {
        await axios.delete(this.baseDomain + this.shopId + '/seamconnectedaccounts/' + accountId + '.json?apikey=' + this.apiKey)
      } catch (e) {
        this.showError(e)
        return
      }
      await this.refreshDevices()
      window.location.reload()
    },
    getSaveData () {
      const exportFields = [
        'id', 
        'igloohome_apikey',
        'ratna_url',
        'ratna_username',
        'ratna_password',
        'ratna_apartments',
        'adax_clientid',
        'adax_clientsecret'
      ]
      const data = exportFields.reduce((a, e) => (a[e] = this.settings[e], a), {})
      data.smartdevices = 1
      return data
    },
    async save (payment) {
      this.saving = true
      const data = this.getSaveData()
      let response
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/settings/1.json?apikey=' + this.apiKey, data)
      } catch (e) {
        console.log(e)
        this.saving = false
        return this.showError(e)
      }
      this.saving = false
      this.saved = true
      this.storeState()
      setTimeout(() => { this.saved = false }, 1000)
      this.showNotification(this._('Changes saved successfully!'))
      this.$emit('save', this.settings)
      this.close()
    },
    servicePanelClass (index) {
      return 'panel panel-' + (this.isServiceEnabled(index) ? 'info' : 'default')
    },
    isServiceEnabled (index) {
      switch (index) {
        case 'seam':
          return this.settings && !!this.settings.seam_connected_accounts
        case 'igloohome':
          return this.settings && !!this.settings.igloohome_apikey
        case 'ratna':
          return this.settings && !!this.settings.ratna_url && !!this.settings.ratna_username && !!this.settings.ratna_password
        case 'yale':
          return this.settings && !!this.settings.yale_apitoken
        case 'adax':
          return this.settings && !!this.settings.adax_clientid && !!this.settings.adax_clientsecret
      }
      return false
    },
    async loadSmartDeviceSettings() {
      const settings = await this.loadVersionedSettings()
      this.origSettings = Object.assign({}, settings)
      this.localSettings = Object.assign({}, settings)
      this.storeState()
    },
    async loadSeamConnectedAccountInfo () {
      try {
        const response = await axios.get(this.baseDomain + this.shopId + '/seamconnectedaccounts.json?apikey=' + this.apiKey)
        if (response.data && response.data.length > 0) {
          this.seamConnectedAccountWarnings = {}
          for (let i = 0; i < response.data.length; i++) {
            const account = response.data[i]
            if (account.warnings && account.warnings.length > 0) {
              this.seamConnectedAccountWarnings[account.connected_account_id] = account.warnings
            }
            if (account.errors && account.errors.length > 0) {
              this.seamConnectedAccountErrors[account.connected_account_id] = account.errors
            }
          }
        }
      } catch (e) {
      }
    }
  },
  components: {
    Datatable,
    DraggableMultiSelector
  },
  mounted () {
    this.loadSmartDeviceSettings()
    this.loadSeamConnectedAccountInfo()
  }
}
</script>

<style scoped>
.panel-collapse {
  overflow-y: hidden;
}
</style>